document.addEventListener("DOMContentLoaded", function () {
	const fixedButton = document.getElementById("fixed-button");

	if (!fixedButton || !fixedButton.classList.contains("reveal-text")) {
		return;
	}

	const parsedDelay = Number(fixedButton.dataset.revealDelay);
	const revealDelay = Number.isFinite(parsedDelay)
		? Math.max(0, parsedDelay)
		: 3000;

	let collapseTimer;

	function expand() {
		window.clearTimeout(collapseTimer);
		fixedButton.classList.add("expanded");
	}

	function collapse() {
		if (
			!fixedButton.matches(":hover") &&
			document.activeElement !== fixedButton
		) {
			fixedButton.classList.remove("expanded");
		}
	}

	if (revealDelay > 0 && fixedButton.classList.contains("expanded")) {
		collapseTimer = window.setTimeout(collapse, revealDelay);
	}

	fixedButton.addEventListener("mouseenter", expand);
	fixedButton.addEventListener("mouseleave", collapse);
	fixedButton.addEventListener("focus", expand);
	fixedButton.addEventListener("blur", collapse);
});
